import axios from 'axios'

export let sendRequest = async (params) => {
  let res = await axios.get('reconciliation', {params})

  return res.data
}



// WEBPACK FOOTER //
// ./src/api/reconciliation.js